import React from 'react';
import { MarketingFeaturesList } from '@sayido/ui';

const FEATURE_ICONS = {
  smsInvitations: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm5-4H7V5h10v10z"
        fill="currentColor"
      />
    </svg>
  ),
  customDomain: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21z"
        fill="currentColor"
      />
    </svg>
  ),
  passwordProtection: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
        fill="currentColor"
      />
    </svg>
  ),
  qrCode: (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 10.6667H12C11.6464 10.6667 11.3072 10.8071 11.0572 11.0572C10.8071 11.3072 10.6667 11.6464 10.6667 12V14M14 14V14.0067M8 4.66667V6.66667C8 7.02029 7.85952 7.35943 7.60948 7.60948C7.35943 7.85952 7.02029 8 6.66667 8H4.66667M2 8H2.00667M8 2H8.00667M8 10.6667V10.6733M10.6667 8H11.3333M14 8V8.00667M8 14V13.3333M2.66667 2H4.66667C5.03486 2 5.33333 2.29848 5.33333 2.66667V4.66667C5.33333 5.03486 5.03486 5.33333 4.66667 5.33333H2.66667C2.29848 5.33333 2 5.03486 2 4.66667V2.66667C2 2.29848 2.29848 2 2.66667 2ZM11.3333 2H13.3333C13.7015 2 14 2.29848 14 2.66667V4.66667C14 5.03486 13.7015 5.33333 13.3333 5.33333H11.3333C10.9651 5.33333 10.6667 5.03486 10.6667 4.66667V2.66667C10.6667 2.29848 10.9651 2 11.3333 2ZM2.66667 10.6667H4.66667C5.03486 10.6667 5.33333 10.9651 5.33333 11.3333V13.3333C5.33333 13.7015 5.03486 14 4.66667 14H2.66667C2.29848 14 2 13.7015 2 13.3333V11.3333C2 10.9651 2.29848 10.6667 2.66667 10.6667Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

const FEATURES = {
  smsInvitations: {
    title: 'SMS Invitations',
    body:
      'Send digital invites, save-the-dates and updates directly to your guests phones. Fast, eco-friendly, and always delivered.',
    iconKey: 'smsInvitations',
  },
  passwordProtection: {
    title: 'Password Protected Website',
    body:
      'Hide your website from prying eyes with a secret password you share only with guests.',
    iconKey: 'passwordProtection',
  },
  customDomain: {
    title: 'Custom Domain',
    body:
      'Stand out with your own personalized website address. Perfect for save-the-dates and making your site easy to remember.',
    iconKey: 'customDomain',
  },
  qrCode: {
    title: 'Smart QR Codes',
    body:
      'Add interactive QR codes to your paper invites. Let guests RSVP instantly by scanning with their phone.',
    iconKey: 'qrCode',
  },
};

const DEFAULT_FEATURE_KEYS = ['passwordProtection', 'customDomain', 'qrCode'];

export default function ThreeColFeatures({
  title = 'Modern features for the modern couple',
  featureKeys = [],
}) {
  const finalFeatures = (featureKeys.length >= 3
    ? featureKeys
    : [...featureKeys, ...DEFAULT_FEATURE_KEYS.slice(0, 3 - featureKeys.length)]
  ).map(key => ({
    ...FEATURES[key],
    icon: FEATURE_ICONS[FEATURES[key].iconKey],
  }));

  return <MarketingFeaturesList title={title} sections={finalFeatures} />;
}
